import { all, AllEffect } from 'redux-saga/effects';
import FormsReducer from './duck/reducer';
import { watchGetForms } from './duck/saga';

function* FormsSaga(): Generator<AllEffect<Generator>> {
  yield all([watchGetForms()]);
}

export { FormsReducer, FormsSaga };
